import { useEffect, useState } from "react";
import AdminLayout from "@/pages/admin/AdminLayout";
import { api, formatINR } from "@/lib/api";
import { toast } from "sonner";

const STATUSES = ["created", "paid", "shipped", "delivered", "cancelled", "failed"];

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);

  const load = () => api.get("/admin/orders").then((r) => setOrders(r.data));

  useEffect(() => {
    load();
  }, []);

  const setStatus = async (id, status) => {
    try {
      await api.put(`/admin/orders/${id}/status`, { status });
      toast.success(`Order marked ${status}`);
      load();
    } catch {
      toast.error("Failed to update status");
    }
  };

  return (
    <AdminLayout title="Orders">
      <div className="card overflow-hidden" data-testid="admin-orders-table">
        <div className="grid grid-cols-12 gap-4 px-4 py-3 border-b border-[#e0d8c8] text-xs uppercase tracking-[0.16em] text-[#6b6b6b]">
          <div className="col-span-3">Order</div>
          <div className="col-span-2">Customer</div>
          <div className="col-span-3">Items</div>
          <div className="col-span-1">Total</div>
          <div className="col-span-3">Status</div>
        </div>
        {orders.length === 0 && (
          <div className="p-6 text-sm text-[#6b6b6b]">No orders yet.</div>
        )}
        {orders.map((o) => (
          <div key={o.id} className="grid grid-cols-12 gap-4 items-start px-4 py-4 border-b border-[#e0d8c8]" data-testid={`admin-order-row-${o.id}`}>
            <div className="col-span-3">
              <div className="font-mono text-xs">{o.id.slice(0, 8)}…</div>
              <div className="text-xs text-[#6b6b6b] mt-1">{new Date(o.created_at).toLocaleString()}</div>
              {o.is_guest && <div className="mt-1 inline-block text-[10px] uppercase tracking-[0.2em] text-[#8b3a3a]">Guest</div>}
              {o.mock && <div className="text-[10px] uppercase tracking-[0.16em] mt-1 text-[#6b6b6b]">Test Mode</div>}
            </div>
            <div className="col-span-2 text-xs">
              <div>{o.shipping?.full_name}</div>
              <div className="text-[#6b6b6b]">{o.user_email}</div>
              <div className="text-[#6b6b6b]">{o.shipping?.city}, {o.shipping?.state}</div>
            </div>
            <div className="col-span-3 text-xs space-y-1">
              {o.items.map((it, i) => (
                <div key={i}>× {it.quantity} — {it.name} {it.size ? `(${it.size})` : ""}</div>
              ))}
              {o.coupon_code && (
                <div className="text-[#8b3a3a] text-[11px] mt-1">Coupon: {o.coupon_code} (−{formatINR(o.discount)})</div>
              )}
            </div>
            <div className="col-span-1 text-sm font-medium">{formatINR(o.amount)}</div>
            <div className="col-span-3">
              <select
                value={o.status}
                onChange={(e) => setStatus(o.id, e.target.value)}
                className="w-full h-10 bg-white border border-[#e0d8c8] focus:border-[#c8532e] outline-none rounded-md px-3 text-xs uppercase tracking-[0.16em]"
                data-testid={`admin-order-status-${o.id}`}
              >
                {STATUSES.map((s) => (
                  <option key={s} value={s}>{s}</option>
                ))}
              </select>
            </div>
          </div>
        ))}
      </div>
    </AdminLayout>
  );
}
